import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';

import { DashboardComponent } from './dashboard.component';
import { DashboardService } from './dashboard.service';
import { AvatarModule } from 'ngx-avatar';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    AvatarModule,
    TranslocoModule
  ],
  declarations: [
    DashboardComponent,
  ],
  entryComponents:[
  ],
  providers: [
    DashboardService
  ]
})
export class DashboardModule { }
